import { LatestBlogPostsBlockClient } from "./LatestBlogPostsBlock.client";
import type { ILatestBlogPostsBlockProps } from "./LatestBlogPostsBlock.props";

export const LatestBlogPostsBlock = (props: ILatestBlogPostsBlockProps) => (
  <LatestBlogPostsBlockClient {...props} />
);
LatestBlogPostsBlock.displayName = "Block::LatestBlogPostsBlock";
